// portfolio.js
import Portfolio from "../assets/images/portfolio-png/portfolio.png";
import Dashboard from "../assets/images/portfolio-png/dashboard.png";
import Kilohealth from "../assets/images/portfolio-png/kilohealth.png";
import ptstore from "../assets/images/portfolio-png/PT-store.webp";
import language from "../assets/images/portfolio-png/multi-langauge.png";
import mantic from "../assets/images/portfolio-png/mantic.png";
import steav from "../assets/images/portfolio-png/steav-new.webp";
import movie from "../assets/images/portfolio-png/pt-movie.webp";
import siemreab1 from "../assets/images/portfolio-png/siemreab-tour-1.jpg";
import siemreab2 from "../assets/images/portfolio-png/siemreab-tour-2.jpg";
import siemreab3 from "../assets/images/portfolio-png/siemreab-tour-3.jpg";
import siemreab4 from "../assets/images/portfolio-png/siemreab4.webp";
import cambrew1 from "../assets/images/portfolio-png/cambrew-1.webp";
import cambrew2 from "../assets/images/portfolio-png/cambrew-2.webp";
import cambrew3 from "../assets/images/portfolio-png/cambrew-3.webp";
import cambrew4 from "../assets/images/portfolio-png/cambrew-4.webp";
import cambrew5 from "../assets/images/portfolio-png/cambrew-5.webp";
import cambrew6 from "../assets/images/portfolio-png/cambrew-6.webp";
import chat from "../assets/images/portfolio-png/real-time-chat.webp";
import psar from "../assets/images/portfolio-png/psar-online.webp";
import portfolioV2 from "../assets/images/portfolio-png/portfolio-v2.webp";

const portfolio = [
  {
    title: "Portfolio",
    category: "Website",
    description: "Website",
    img: Portfolio,
    link: "https://pheaktra-portfolio.vercel.app/",
  },
  {
    title: "Portfolio V2",
    category: "Website",
    description: "Website",
    img: portfolioV2,
    link: "https://pheaktra-portfolio-brown.vercel.app/",
  },
  {
    title: "Mantic Cup",
    category: "Website",
    description: "Website",
    img: mantic,
    link: "https://manticcup.vercel.app/",
  },
  {
    title: "Dashboard KiloHealth",
    category: "System", // Example
    description: "System",
    img: Dashboard,
    link: "https://pheaktra-portfolio.vercel.app/",
  },
  {
    title: "KiloHealth",
    category: "Website",
    description: "Website",
    img: Kilohealth,
    link: "https://pheaktra-portfolio.vercel.app/",
  },
  // {
  //   title: "School Management",
  //   category: "System",
  //   description: "System",
  //   img: student,
  //   link: "https://pheaktra-portfolio.vercel.app/",
  // },
  {
    title: "Laravel Multi Language",
    category: "Website",
    description: "Website",
    img: language,
    link: "https://pheaktra-portfolio.vercel.app/",
  },
  {
    title: "Steav News",
    category: "Website",
    description: "Website",
    img: steav,
    link: "https://steav-news-one.vercel.app/",
  },
  {
    title: "NextJS API",
    category: "Website",
    description: "Website",
    img: ptstore,
    link: "https://nextjs-api-black-six.vercel.app/",
  },
  {
    title: "PT Movie NextJS",
    category: "Website",
    description: "Website",
    img: movie,
    link: "https://pt-movie-next-js.vercel.app/",
  },
  {
    title: "Siemreab Tour 2024",
    category: "Blog",
    description: "Study tour",
    img: [siemreab4, siemreab3, siemreab1, siemreab2],
    // link: "",
  },
  {
    title: "Cambrew Tour 2023",
    category: "Blog",
    description: "Study tour",
    img: [cambrew1, cambrew2, cambrew3, cambrew4, cambrew5, cambrew6],
    // link: "",
  },
  {
    title: "Realtime Chat App",
    category: "Website",
    description: "MERN Stack Project - React.js & Socket.io ",
    img: chat,
    link: "https://imessage-gz4s.onrender.com",
  },
  {
    title: "Full Stack E-Commerce",
    category: "Website",
    description: "PERN Stack Project - React.js",
    img: psar,
    link: "https://psar-online.onrender.com",
  },
];

export { portfolio };
